/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_Staff_Role_JudgeInputs */



/**
* | output |
* | --- |
* | "Judge" |
*
* @param {Tournaments_Lib_Staff_Role_JudgeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_staff_role_judge = /** @type {((inputs?: Tournaments_Lib_Staff_Role_JudgeInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Staff_Role_JudgeInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Judge")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Arbitre")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("裁判")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("裁判")
	if (locale === "ko") return /** @type {LocalizedString} */ ("심판")
	return /** @type {LocalizedString} */ ("Judge")
});